// extracted by mini-css-extract-plugin
export default {"wrapper":"no-data_wrapper__fGJtw","textWrapper":"no-data_textWrapper__1CArG","title":"no-data_title__Mn7sg","description":"no-data_description__BHUq2"};